import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const ArbitrumLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M10.992.23a2.254 2.254 0 0 1 1.987 0l8.668 4.986a2.22 2.22 0 0 1 1.041 1.783v9.974a2.202 2.202 0 0 1-.848 1.66l-9.008 5.216a2.224 2.224 0 0 1-1.683-.028c-.03-.013-.115-.061-.238-.13-.078-.046-.176-.1-.285-.162L7.328 21.63l.75-1.271 3.668 2.11a.76.76 0 0 0 .528.01l3.101-1.797 3.058-1.772.855-.496 1.659-.961a.726.726 0 0 0 .073-.072l-.075.07a.736.736 0 0 0 .272-.535v-1.512l-4.753-7.398-1.763 2.99 4.585 7.417.001-.002-.858.499-4.343-6.854-2.022 3.429 3.311 5.195-3.1 1.798a.76.76 0 0 1-.53-.01l-.39-.226-3.278-1.886 7.864-13.34-3.485.01-7.887 13.014-.918-.528 7.793-12.494h-.003l-1.32-.036c-1.128-.015-2.34.277-2.898 1.187L1.31 17.314V6.994a2.209 2.209 0 0 1 1.255-1.881L6.49 2.838l.524-.304c1.325-.77 2.65-1.537 3.978-2.302V.23Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};